export var TABLE = /* @__PURE__ */ ((TABLE2) => {
  TABLE2["ACCOUNT"] = "account";
  TABLE2["EMPLOYEE"] = "employee";
  TABLE2["ADDRESS"] = "address";
  TABLE2["ATTENTIVE_ACCOUNT"] = "attentive_account";
  TABLE2["DRIP_ACCOUNT"] = "drip_account";
  TABLE2["INSTRUMENT"] = "instrument";
  TABLE2["BUSINESS_DETAILS"] = "business_details";
  TABLE2["API_CREDENTIAL"] = "api_credential";
  TABLE2["SHOPIFY_STORE"] = "shopify_store";
  TABLE2["WOO_STORE"] = "woo_store";
  TABLE2["AUTHORIZATION"] = "charge_authorization";
  TABLE2["CHARGE"] = "charge";
  TABLE2["REFUND"] = "refund";
  TABLE2["CHECKOUT"] = "checkout";
  TABLE2["SUBSCRIPTION"] = "subscription";
  TABLE2["ORDER"] = "orders";
  TABLE2["PAYPAL_ACCOUNT"] = "paypal_account";
  TABLE2["PAYPAL_ORDER"] = "paypal_order";
  TABLE2["MESSAGE"] = "message";
  TABLE2["CUSTOM_FLOW"] = "flow";
  TABLE2["FLOW_INSTANCE_GROUP"] = "flow_instance_group";
  TABLE2["FLOW_TEMPLATE"] = "flow_template";
  TABLE2["SHORT_URL"] = "short_url";
  TABLE2["SHORT_TOKEN"] = "short_token";
  TABLE2["INBOUND_KEYWORD"] = "inbound_keyword";
  TABLE2["PROFILE_SETTINGS"] = "profile_settings";
  TABLE2["POSTSCRIPT_APP"] = "postscript_app";
  TABLE2["PERMISSION"] = "permission";
  TABLE2["PARTIAL_CUSTOMER"] = "partial_customer";
  TABLE2["TWILIO_ACCOUNT"] = "twilio_account";
  TABLE2["TELNYX_ACCOUNT"] = "telnyx_account";
  TABLE2["INFOBIP_ACCOUNT"] = "infobip_account";
  TABLE2["KLAVIYO_ACCOUNT"] = "klaviyo_account";
  TABLE2["STRIPE_ACCOUNT"] = "stripe_account";
  TABLE2["BITLY_ACCOUNT"] = "bitly_account";
  TABLE2["STRIPE_CHARGE"] = "stripe_charge";
  TABLE2["STRIPE_CUSTOMER"] = "stripe_customer";
  TABLE2["MAVERICK_ACCOUNT"] = "maverick_account";
  TABLE2["MAVERICK_AUTHORIZATION"] = "maverick_authorization";
  TABLE2["AUTHORIZE_DOT_NET_ACCOUNT"] = "authorize_dot_net_account";
  TABLE2["AUTHORIZE_DOT_NET_TRANSACTION"] = "authorize_dot_net_transaction";
  TABLE2["CUSTOM_CONTENT"] = "custom_content";
  TABLE2["EVENT"] = "event";
  TABLE2["PRICING_RULE"] = "pricing_rule";
  TABLE2["FEE"] = "fee";
  TABLE2["CREDIT"] = "credit";
  TABLE2["FEE_AGGREGATE"] = "fee_aggregate";
  TABLE2["ATTRIBUTION"] = "attribution";
  TABLE2["SENDLANE_ACCOUNT"] = "sendlane_account";
  TABLE2["YOTPO_ACCOUNT"] = "yotpo_account";
  TABLE2["MERCHANT_FAQ"] = "merchant_faq";
  TABLE2["META_ACCOUNT"] = "meta_account";
  TABLE2["EXPERIMENT"] = "experiment";
  TABLE2["EXPERIMENT_GROUP"] = "experiment_group";
  TABLE2["EXPERIMENT_INSTANCE"] = "experiment_instance";
  TABLE2["SEGMENT"] = "segment";
  TABLE2["CUSTOMER_PROPERTY"] = "customer_property";
  TABLE2["STAT_AGGREGATE"] = "stat_aggregate";
  TABLE2["TRIGGER"] = "trigger";
  TABLE2["MOCK_MESSAGE_PROVIDER"] = "mock_message_provider";
  TABLE2["POPUP"] = "popup";
  TABLE2["INTENT"] = "intent";
  TABLE2["PRODUCT_EMBEDDING"] = "product_embedding";
  TABLE2["OMNISEND_ACCOUNT"] = "omnisend_account";
  TABLE2["SHOPIFY_PRODUCT"] = "shopify_product";
  TABLE2["PRODUCT_CATEGORY"] = "product_category";
  return TABLE2;
})(TABLE || {});
export var COLLECTION = /* @__PURE__ */ ((COLLECTION2) => {
  COLLECTION2["SCHEDULED_TASK"] = "scheduled_task";
  COLLECTION2["REQUEST"] = "request";
  COLLECTION2["EVENT"] = "event";
  COLLECTION2["LLM_LOG"] = "llm_log";
  COLLECTION2["LLM_HOURLY_AGGREGATE"] = "llm_hourly_aggregate";
  COLLECTION2["CUSTOM_FLOW_INSTANCE"] = "custom_flow_instance";
  COLLECTION2["TEST"] = "test";
  return COLLECTION2;
})(COLLECTION || {});
export var DATABASE_ERROR = /* @__PURE__ */ ((DATABASE_ERROR2) => {
  DATABASE_ERROR2["UNKNOWN"] = "unknown";
  DATABASE_ERROR2["DUPLICATE"] = "duplicate";
  DATABASE_ERROR2["CONSTRAINT_ON_CONFLICT_NOT_FOUND"] = "constraint_on_conflict_not_found";
  DATABASE_ERROR2["NOT_FOUND"] = "not_found";
  return DATABASE_ERROR2;
})(DATABASE_ERROR || {});
export const ONETEXT_ACCOUNT_ID_TRACKING_FRIENDLY = "00000000-0000-0000-0000-000000000000";
